import NoData from "@/components/NoData";
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import APICell from "./APICell";
import { API_COLUMNS, API_COLUMNS_ID } from "./constants";
import DeleteModal from "./Delete";
import { APIDataTable } from "./helpers";
import useDelete from "./useDelete";

const ListMyKey: React.FC<{
  list: APIDataTable[];
  loading: boolean;
  getData: () => void;
}> = ({ list, loading, getData }) => {
  const { 
    onOpenChangeDelete, 
    isOpenDelete, 
    onOpenDelete, 
    loading: loadingDel,
    handleDelete 
  } = useDelete();

 return (
   <div className="mt-10">
     <Table
        aria-label="Activity table"
        removeWrapper
        isHeaderSticky
        classNames={{
          thead: 'border-none',
          tr: '!shadow-none',
          th: 'sm:text-[13px]',
          td: 'lg:text-[13px] sm:text-[12px]',
          base: 'xl:overflow-x-auto xl:scrollbar-custom',
        }}
      >
        <TableHeader columns={API_COLUMNS}>
          {(column) => (
            <TableColumn
              aria-expanded={column.id === API_COLUMNS_ID.Name}
              key={column.id}
              className={`bg-gray-50 text-[14px] font-[400] text-[#505665] sm:aria-expanded:sticky sm:aria-expanded:left-0 sm:aria-expanded:z-[1]`}
            >
              {column.title}
            </TableColumn>
          )}
        </TableHeader>
        <TableBody items={list} isLoading={loading} emptyContent={<NoData className="h-[350px]" />}>
          {(item) => (
            <TableRow key={item.id} className="border-b-1 border-[#F0F2FA] last:border-none">
              {(columnKey) => (
                <TableCell
                  aria-expanded={columnKey === API_COLUMNS_ID.Name}
                  className="bg-white py-4 sm:py-2 sm:aria-expanded:sticky sm:aria-expanded:left-0 sm:aria-expanded:z-[1]"
                >
                  <APICell onOpenDel={onOpenDelete} data={item} columnKey={columnKey} />
                </TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
      <DeleteModal 
        isOpen={isOpenDelete}
        onOpenChange={onOpenChangeDelete}
        loading={loadingDel}
        onSubmit={() => handleDelete(getData)}
      />
   </div>
 );
}

export default ListMyKey;